import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
export var ConditionalFormSection = function (_a) {
    var children = _a.children, forceShow = _a.forceShow, name = _a.name, _b = _a.valueCheck, valueCheck = _b === void 0 ? function (value) { return !!value; } : _b;
    var getValues = useFormContext().getValues;
    var hasValue = useMemo(function () { return valueCheck(getValues(name)); }, [getValues]);
    if (!forceShow && !hasValue)
        return _jsx(_Fragment, {});
    return _jsx(_Fragment, { children: children });
};
